<template>
    <v-expansion-panel-header @click.native="$emit('click')" class="block-separator kimsa-elevation">
        <v-row align="center">
            <v-col cols="2" v-if="!hideStudentInfo">
                <div v-if="block.isCircuit">
                    <v-btn :loading="loadingComplete && clicked" :disabled="readonly || block.completed" color="primary"
                        class="black--text" small depressed fab dark @click.stop="showTimerDialog">
                        <v-icon>mdi-timer-outline</v-icon>
                    </v-btn>
                    <timer-dialog :type="block.type" :duration="block.sets * 60" :tabata="block.tabata" @hide="setBlockComplete" ref="timer" />
                </div>
                <v-switch v-else dense dark inset class="ma-0 pa-0" hide-details
                    :color="block.completed ? 'primary' : 'backGroundPrimary'" :loading="loadingComplete && clicked"
                    v-model="block.completed" @click.stop="stopPropagation" @change="setBlockComplete"
                    :readonly="readonly" />
            </v-col>
            <v-col :cols="hideStudentInfo ? 12 : 10">
                <div class="title-separator">
                    {{ $tc('common.blocks', 1) }} {{ index + 1 }} {{ circuitType }}
                </div>
                <div class="text-center mt-1">
                    <span class="description-separator">
                        <v-icon size="15" color="primary">mdi-dumbbell</v-icon>
                        {{ exercisesText }}
                    </span>
                    <span class="mr-1"></span>
                    <span class="description-separator">
                        <v-icon size="15" color="primary">{{ durationIcon }}</v-icon> {{ blockDuration }}
                    </span>
                </div>
            </v-col>
        </v-row>
    </v-expansion-panel-header>
</template>

<script>
import TimerDialog from './TimerDialog.vue'
export default {
    components: { TimerDialog },
    name: "BlockExpansionHeader",
    props: {
        hideStudentInfo: {
            type: Boolean,
            default: false,
        },
        block: {
            type: Object,
            default: null,
        },
        loadingComplete: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        index: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {
            clicked: false,
        }
    },
    computed: {
        durationIcon(vm = this) {
            if (vm.block.type === 'time') return 'mdi-refresh'
            return 'mdi-clock-outline'
        },
        blockDuration(vm = this) {
            if (vm.block.isCircuit) {
                let sets = vm.block.sets
                if (vm.block.type === 'time') {
                    return `${sets} ${vm.$t('common.laps').toUpperCase()}`
                }
                if (vm.block.type === 'tabata') {
                    let minutes = vm.block.tabata.minutes
                    let timeWork = vm.block.tabata.timeWork
                    let timeRest = vm.block.tabata.timeRest
                    return `(${timeWork}"X${timeRest}"X${minutes}')X${sets}'`
                }
                return `${sets}'`
            }
            let minutes = 0
            vm.block.exercises.forEach(exercise => {
                minutes += exercise?.config?.sets?.length || vm.block.sets || 0
            })
            let minutesAdded = Number(minutes * 1.3).toFixed()

            let minutesString = vm.$tc(`common.minutes`, Number(minutes) === 1 ? 1 : 2)
            if (Number(minutes) === Number(minutesAdded)) return `${minutes} ${minutesString.toLowerCase()}`
            return `${minutes}-${minutesAdded} ${minutesString.toLowerCase()}`
        },
        exercisesText(vm = this) {
            let exercises = vm.block.exercises?.filter(ex => ex.type === 'exercise').length || 0
            return `${exercises}  ${vm.$tc('exercises.exercises', exercises > 1 ? 2 : 1)}`
        },
        circuitType(vm = this) {
            if (!vm.block.isCircuit) return null
            return `- ${vm.$t(`circuits.${vm.block.type}`)}`
        }
    },
    methods: {
        stopPropagation(event) {
            event.stopPropagation();
        },
        setBlockComplete(event) {
            const vm = this
            vm.clicked = true
            vm.$emit('complete', event || true, vm.index)
        },
        showTimerDialog(event) {
            const vm = this;
            vm.$refs.timer.show()
            event.stopPropagation();
        }
    },
    watch: {
        loadingComplete(val) {
            if (!val) this.clicked = false
        }
    }
}
</script>

<style scoped>
.block-separator {
    background-color: var(--v-backGroundPrimary-base);
    color: var(--v-primary-base);
    border: 1px solid #666666;
}

.title-separator {
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
}

.description-separator {
    font-size: 13px;
    text-transform: uppercase;
}

>>>.v-expansion-panel-header__icon>i {
    color: #FFFFFF !important;
}
</style>